import apiClient from '../apiClient';
import { PUT_CITY_GROUP_URL } from '../apiUrl';

const putCityGroupApi = (id, data) => {
  return apiClient.put(PUT_CITY_GROUP_URL(id), data);
};

export default putCityGroupApi;
